window.axios = require("axios");

const defaultSwiperConfig = {
	slidesPerView: 2,
	spaceBetween: 10,
	breakpoints: {
		992: {
			slidesPerView: 4
		},
	},
	scrollbar: {
		el: '.collection-swiper-scrollbar.swiper-scrollbar',
	},
	navigation: {
		nextEl: '.recommended-products .swiper-button-next',
		prevEl: '.recommended-products .swiper-button-prev',
	},
	lazy: {
		enabled: true,
		checkInView: false,
		loadOnTransitionStart: true,
		loadPrevNext: true,
		loadPrevNextAmount: 1
	},
};

function initProductRecommendations(section) {
	const productRecommendationsSection = section || document.querySelector('.product-recommendations');
	if (!productRecommendationsSection || !productRecommendationsSection.dataset.url) {
		return Promise.resolve();
	}

	const url = productRecommendationsSection.dataset.url;
	return axios.get(url, {})
		.then(function (response) {
			const text = response.data;
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('.product-recommendations');
			if (recommendations && recommendations.innerHTML.trim().length) {
				productRecommendationsSection.innerHTML = recommendations.innerHTML;
				const recommended_slider = html.querySelector('.recommendations-slider');
				const recommended_slider_loop = recommended_slider.dataset.loop;
				const swiperConfig = {
					...defaultSwiperConfig,
					loop: recommended_slider_loop === "true",
				};
				new window.swiper('.recommendations-slider', swiperConfig);
			}
		})
		.catch(function (error) {
			window.log(error);
		});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => initProductRecommendations());
} else {
	initProductRecommendations();
}

window.initProductRecommendations = initProductRecommendations;

module.exports = { initProductRecommendations };